import React, { useRef, useState, useContext, useEffect } from "react";
import AlertComponent from "../../components/AlertComponent";
import { Button, Spinner } from "react-bootstrap";
import { errorState, initialState } from "../../components/enum";
import axios from "axios";
import { UserContext } from "../page_listen";
import { languagePayment, methodPayment } from "./json";

function TabCode({ idLanguage, title, button }) {
  const id = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(initialState);
  const [disabled, setDisabled] = useState(true);
  const [data, setData] = useState([]);
  const [textLang, setTextLang] = useState([]);
  const valueCode = useRef();

  const disabledBtn = (e) => {
    if (e.target.value === "") setDisabled(true);
    else setDisabled(false);
  };

  useEffect(() => {
    const lang = languagePayment.filter((el) => el.id === (id || idLanguage));
    setTextLang(lang);
  }, []);

  const audioToListen = () => {
    setLoading(true);
    setError(initialState);
    const valueToInput = valueCode.current.value;
    axios
      .get(
        `getaudiotolisten?code=${valueToInput}&language_id=${id || idLanguage}`
      )
      .then((res) => {
        setLoading(false);
        if (Array.isArray(res.data) === false) {
          setLoading(false);
          setError({
            message: res.data,
            type: "danger",
            showError: true,
          });
          return;
        }
        window.location.href = `${window.location.origin}/audios?id=${id || idLanguage
          }&code=${valueToInput}`;
      })
      .catch(() => {
        setError(errorState);
        setLoading(false);
      });
  };

  return (
    <>
      <div className="py-4 f-size22" style={{ textAlign: "center" }}>
        <span style={{ fontWeight: "bold" }}>
          {title || textLang[0]?.password}
        </span>
      </div>
      <div className="d-flex justify-content-center">
        <input
          style={{ width: "250px", height: "45px" }}
          className="text-center py-2 f-size26"
          onChange={disabledBtn}
          ref={valueCode}
          type="text"
        />
      </div>
      <div className="d-flex justify-content-center my-4">
        <Button
          className="d-flex gap-2 align-items-center"
          disabled={disabled || loading}
          onClick={() => audioToListen()}
        >
          {loading && <Spinner size="sm" animation="border" />}
          <span>{button || textLang[0]?.listen}</span>
        </Button>
      </div>
      {data.length === 0 && error === true ? (
        <AlertComponent
          message={"The code you entered is incorrect"}
          type={"warning"}
        />
      ) : (
        <>
          {data.length !== 0 ? (
            <div>
              {data.map((el) => (
                <div key={el.Id} className="pb-4">
                  <p style={{ fontWeight: "bold" }}>{el.Name}</p>
                  <audio className="w-100" controls controlsList="nodownload">
                    <source src={el.AudioFile.Name} />
                  </audio>
                </div>
              ))}
            </div>
          ) : (
            <></>
          )}
        </>
      )}
      {error.showError ? (
        <AlertComponent message={error.message} type={error.type} />
      ) : (
        <></>
      )}
    </>
  );
}

export default TabCode;
